'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToBasket = undefined;

var _AddToBasket2 = require('./AddToBasket');

var _AddToBasket3 = _interopRequireDefault(_AddToBasket2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AddToBasket = _AddToBasket3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/AddToBasket/index.js
// module id = 1613
// module chunks = 0